export const DLQ_QUEUES: ReadonlyArray<string> = [
  "webhook-push",
  "metadata-sync",
  "email-send",
  "relation-notify",
  "agent-status",
  "artifact-expire",
  "push-notify",
  "broadcast-notify",
  "offline-deliver",
  "key-rotation",
  "group-deliver",
  "audit-write",
  "export-task",
  "r2-sync",
  "identity-rotation-notify",
];

export const DLQ_PAGE_SIZE = 20;
